import './applied_review_status_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ReviewModeAppliedReviewStatusView extends Monitoring.Views.SocialContents.Filters.AppliedReviewStatusView
  name: 'review_status'
  alias: 'Review Status'
  humanize: true
  allowRemove: false
